import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "@/components/Login.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/Dashboard.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
